export default {
    list: {
        title: "Credits",
        name: "credits",
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        awayLimit: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                method: true,
                name: "Actions",
                link: true,
                buttons: [
                    {
                        text: "New credit",
                        icon: "add",
                        action: "addCredit",
                        link: "/credits/new",
                        color: "primary",
                    },
                    {
                        text: "new_payment",
                        icon: "attach_money",
                        action: "addPayment",
                        color: "primary",
                        class: "",
                    }
                ]
            }
        },
        columns: [
            {
                type: "checkbox",
                elements: [
                    {
                        items: [
                            {
                                class: "",
                                type: "checkbox",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Id",
                class: "",
                elements: [
                    {
                        items: [
                            {
                                class: "",
                                name: "code",
                                type: "text",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Service",
                elements: [
                    {
                        items: [
                            {
                                class: "ouka",
                                name: "service",
                                elements: [
                                    {
                                        items: [
                                            {
                                                name: "fullName",
                                                class: "font-bold text-gray-700",
                                                icone: "contacts",
                                            }
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },

            {
                name: "Amount",
                class: "",
                elements: [
                    {
                        items: [
                            {
                                class: "",
                                name: "amount",
                                type: "text",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Comment",
                class: "",
                elements: [
                    {
                        items: [
                            {
                                class: "",
                                name: "comment",
                                type: "text",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Payment",
                class: "",
                elements: [
                    {
                        items: [
                            {
                                class: "",
                                name: "payment",
                                type: "text",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Date creation",
                class: "",
                elements: [
                    {
                        items: [
                            {
                                class: "",
                                date: true,
                                name: "date",
                                type: "text",
                            },
                        ],
                    },
                ],
            },
            {
                name: "Status",
                class: "text-center",
                elements: [
                    {
                        items: [
                            {
                                class:
                                    "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                                name: "status",
                                options: (item) => {
                                    switch (item) {
                                        case "not applied":
                                            return "color: rgb(233 147 19); border-color: rgb(233 147 19);";
                                            break;
                                        case "applied":
                                            return "color:rgb(58 217 18); border-color: rgb(58 217 18);";
                                            break;
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [
                {
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: "update",
                    link: "/credits/edit",
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: "delete",
                    tooltip: "Delete",
                },
            ],
        },
        filters: {
            name: "credits",
            hasFilterdate: true,
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "id ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    },
                },
                champs: [
                    {
                        label: "Status",
                        key: "status",
                        name: "name",
                        value: null,
                        values: [],
                        class:
                            "py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white",
                        type: "select",
                    },
                    {
                        label: "Credits date",
                        key: "Range_date",
                        value: null,
                        placeholder: "Date Range ...",
                        type: "date_range",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full",
                    },
                ],
            },
        },
    },
};
